import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { ModelService } from 'src/app/services/model.service';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-modal-language',
  templateUrl: './modal-language.page.html',
  styleUrls: ['./modal-language.page.scss'],
})
export class ModalLanguagePage implements OnInit {
  languageSelected: any;

  constructor(  
      private languageService: LanguageService,
      private modalController: ModalController,
      private modelService: ModelService
    ) { }

  async ngOnInit() {
    this.languageSelected = await this.modelService.getRoot('language');
    this.languageSelected = (this.languageSelected == null) ? this.languageService.check() : this.languageSelected;
  }

  set(event: any): any {
    this.languageSelected = event.target.value;
    return this.languageService.set(this.languageSelected); 
  }

  close(){
    this.modalController.dismiss({
      'dismissed': true,
  
    });
  }
}
